module.exports = __webpack_public_path__ + "media/images/emblems/Fontenais-Blazono-50b289ea1f0c3f2359b7ecbf357ef6f1.png";